export default {
  navigationHeight: {
    mobile: '3.65rem',
    desktop: '4.875rem',
  },
  sectionBackgroundGradient: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.04) 2rem, rgba(255, 255, 255, 0) 7rem, rgba(255, 255, 255, 0) 100%)',
};
